import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'AboutUs' })((theme) => ({
    container: {
        maxWidth: 856,
        margin: 'auto'
    },
    title: {
        marginTop: 40,
        marginBottom: 12,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginTop: 40,
            marginBottom: 24
        }
    },
    subtitle: {
        margin: '0 auto',
        maxWidth: 640,
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: 500,
        lineHeight: '27px',
        letterSpacing: '-0.54px'
    },
    sections: {
        marginTop: 80,
        marginBottom: 120,
        display: 'grid',
        gridTemplateAreas: `
            "ceo co-founder"
            "head-of-revenue others"
            "promo promo"
            "requisites requisites"
       `,
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: 'auto',
        gap: 24,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            display: 'flex',
            flexDirection: 'column',
            gap: 24,
            marginTop: 40,
            marginBottom: 96
        }
    },
    image: {
        borderRadius: 1000,
        width: 80,
        height: 80,
        marginBottom: 8,
        objectFit: 'contain',
        background: 'transparent'
    },
    letterAvatar: {
        borderRadius: 1000,
        display: 'flex',
        background: '#fff',
        width: 80,
        height: 80,
        justifyContent: 'center',
        alignItems: 'center',
        color: '#232323',
        fontSize: 24,
        fontWeight: 700,
        lineHeight: '36px',
        letterSpacing: '-0.72px'
    },
    ceo: {
        gridArea: 'ceo'
    },
    coFounder: {
        gridArea: 'co-founder'
    },
    headOfRevenue: {
        gridArea: 'head-of-revenue'
    },
    others: {
        gridArea: 'others'
    },
    promo: {
        gridArea: 'promo'
    },
    requisites: {
        gridArea: 'requisites'
    },
    customers: {
        margin: '160px auto',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            margin: '96px auto'
        }
    }
}));
